import React, { useState } from 'react';
import { CommandCenterLayout } from '../../components/layout/CommandCenterLayout';
import { DataTable } from '../../components/ui/DataTable';
import { StatusBadge, StatusType } from '../../components/ui/StatusBadge';
import { Button } from '../../components/ui/Button';
import { Download, Filter, Eye, Search, BarChart3, TrendingUp, AlertCircle, CheckCircle2, ArrowUp, ArrowDown, Minus, FileText } from 'lucide-react';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { Modal } from '../../components/ui/Modal';
import { Textarea } from '../../components/ui/Textarea';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
// Mock Data
const mockData = [{
  id: 1,
  name: 'Kota Surabaya',
  province: 'Jawa Timur',
  score: 92,
  status: 'hijau',
  reports: 145,
  evidenceRate: '98%',
  sla: '1.2 hari',
  trend: '+2.5%',
  trendDir: 'up'
}, {
  id: 2,
  name: 'DKI Jakarta',
  province: 'DKI Jakarta',
  score: 88,
  status: 'hijau',
  reports: 320,
  evidenceRate: '95%',
  sla: '2.1 hari',
  trend: '+1.1%',
  trendDir: 'up'
}, {
  id: 3,
  name: 'Kota Bandung',
  province: 'Jawa Barat',
  score: 85,
  status: 'hijau',
  reports: 112,
  evidenceRate: '94%',
  sla: '1.8 hari',
  trend: '-0.5%',
  trendDir: 'down'
}, {
  id: 4,
  name: 'Kab. Bekasi',
  province: 'Jawa Barat',
  score: 72,
  status: 'kuning',
  reports: 45,
  evidenceRate: '82%',
  sla: '4.5 hari',
  trend: '+5.2%',
  trendDir: 'up'
}, {
  id: 5,
  name: 'Kota Medan',
  province: 'Sumatera Utara',
  score: 68,
  status: 'kuning',
  reports: 56,
  evidenceRate: '78%',
  sla: '3.2 hari',
  trend: '-1.2%',
  trendDir: 'down'
}, {
  id: 6,
  name: 'Kota Makassar',
  province: 'Sulawesi Selatan',
  score: 75,
  status: 'hijau',
  reports: 88,
  evidenceRate: '90%',
  sla: '2.5 hari',
  trend: '+0.8%',
  trendDir: 'up'
}, {
  id: 7,
  name: 'Kab. Tangerang',
  province: 'Banten',
  score: 55,
  status: 'merah',
  reports: 23,
  evidenceRate: '65%',
  sla: '6.8 hari',
  trend: '-3.5%',
  trendDir: 'down'
}, {
  id: 8,
  name: 'Kota Semarang',
  province: 'Jawa Tengah',
  score: 82,
  status: 'hijau',
  reports: 95,
  evidenceRate: '92%',
  sla: '2.0 hari',
  trend: '+1.5%',
  trendDir: 'up'
}, {
  id: 9,
  name: 'Kota Denpasar',
  province: 'Bali',
  score: 79,
  status: 'hijau',
  reports: 67,
  evidenceRate: '88%',
  sla: '2.4 hari',
  trend: '+0.2%',
  trendDir: 'up'
}, {
  id: 10,
  name: 'Kota Balikpapan',
  province: 'Kalimantan Timur',
  score: 84,
  status: 'hijau',
  reports: 72,
  evidenceRate: '93%',
  sla: '1.9 hari',
  trend: '+1.8%',
  trendDir: 'up'
}];
const trendData = [{
  month: 'Sep',
  score: 78
}, {
  month: 'Okt',
  score: 82
}, {
  month: 'Nov',
  score: 80
}, {
  month: 'Des',
  score: 85
}, {
  month: 'Jan',
  score: 88
}, {
  month: 'Feb',
  score: 92
}];
const categoryScoreData = [{
  category: 'Pelaporan',
  score: 95,
  fullMark: 100,
  weight: '30%'
}, {
  category: 'Respon Isu',
  score: 88,
  fullMark: 100,
  weight: '25%'
}, {
  category: 'Event',
  score: 90,
  fullMark: 100,
  weight: '20%'
}, {
  category: 'Edukasi',
  score: 85,
  fullMark: 100,
  weight: '15%'
}, {
  category: 'Inovasi',
  score: 92,
  fullMark: 100,
  weight: '10%'
}];
export function SkoringDaerahPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRegion, setSelectedRegion] = useState<any | null>(null);
  const [isExporting, setIsExporting] = useState(false);
  const [adminNote, setAdminNote] = useState('');
  const handleExport = () => {
    setIsExporting(true);
    // Simulate export
    setTimeout(() => {
      setIsExporting(false);
      // In real app, trigger download
    }, 2000);
  };
  const filteredData = mockData.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()) || item.province.toLowerCase().includes(searchTerm.toLowerCase()));
  const columns = [{
    header: 'Nama Daerah',
    cell: (row: any) => <div data-id="element-2449">
          <div className="font-medium text-gray-900" data-id="element-2450">{row.name}</div>
          <div className="text-xs text-gray-500" data-id="element-2451">{row.province}</div>
        </div>
  }, {
    header: 'Skor Total',
    cell: (row: any) => <div className="font-bold text-gray-900 text-lg" data-id="element-2452">{row.score}</div>
  }, {
    header: 'Status',
    cell: (row: any) => <StatusBadge status={row.status as StatusType} data-id="element-2453">
          {row.status === 'hijau' ? 'Baik' : row.status === 'kuning' ? 'Perlu Perhatian' : 'Bermasalah'}
        </StatusBadge>
  }, {
    header: 'Tren (30 Hari)',
    cell: (row: any) => <div className="flex items-center gap-1" data-id="element-2454">
          {row.trendDir === 'up' ? <ArrowUp className="h-3 w-3 text-green-600" data-id="element-2455" /> : row.trendDir === 'down' ? <ArrowDown className="h-3 w-3 text-red-600" data-id="element-2456" /> : <Minus className="h-3 w-3 text-gray-400" data-id="element-2457" />}
          <span className={row.trendDir === 'up' ? 'text-green-600 font-medium' : row.trendDir === 'down' ? 'text-red-600 font-medium' : 'text-gray-500'} data-id="element-2458">
            {row.trend}
          </span>
        </div>
  }, {
    header: 'Laporan Valid',
    accessorKey: 'reports' as const
  }, {
    header: 'Kelengkapan Bukti',
    accessorKey: 'evidenceRate' as const
  }, {
    header: 'SLA Respon Isu',
    accessorKey: 'sla' as const
  }, {
    header: 'Aksi',
    cell: (row: any) => <Button variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={() => setSelectedRegion(row)} data-id="element-2459">
          <Eye className="h-4 w-4 text-gray-500" data-id="element-2460" />
        </Button>
  }];
  return <CommandCenterLayout title="Skoring Kinerja Daerah" subtitle="Evaluasi kinerja pengelolaan sampah berbasis data laporan dan respon isu" data-id="element-2461">
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6" data-id="element-2462">
        <div className="bg-white p-4 rounded-lg border shadow-sm flex items-center gap-4" data-id="element-2463">
          <div className="p-3 bg-green-100 rounded-full text-green-600" data-id="element-2464">
            <CheckCircle2 className="h-6 w-6" data-id="element-2465" />
          </div>
          <div data-id="element-2466">
            <p className="text-sm text-gray-500" data-id="element-2467">Rata-rata Skor</p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-2468">78.5</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg border shadow-sm flex items-center gap-4" data-id="element-2469">
          <div className="p-3 bg-blue-100 rounded-full text-blue-600" data-id="element-2470">
            <TrendingUp className="h-6 w-6" data-id="element-2471" />
          </div>
          <div data-id="element-2472">
            <p className="text-sm text-gray-500" data-id="element-2473">Tren Nasional</p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-2474">+1.2%</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg border shadow-sm flex items-center gap-4" data-id="element-2475">
          <div className="p-3 bg-yellow-100 rounded-full text-yellow-600" data-id="element-2476">
            <AlertCircle className="h-6 w-6" data-id="element-2477" />
          </div>
          <div data-id="element-2478">
            <p className="text-sm text-gray-500" data-id="element-2479">Perlu Perhatian</p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-2480">12</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg border shadow-sm flex items-center gap-4" data-id="element-2481">
          <div className="p-3 bg-purple-100 rounded-full text-purple-600" data-id="element-2482">
            <BarChart3 className="h-6 w-6" data-id="element-2483" />
          </div>
          <div data-id="element-2484">
            <p className="text-sm text-gray-500" data-id="element-2485">Total Daerah</p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-2486">514</p>
          </div>
        </div>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm border mb-6" data-id="element-2487">
        <div className="flex flex-col md:flex-row gap-4 items-end md:items-center justify-between" data-id="element-2488">
          <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto flex-1" data-id="element-2489">
            <div className="relative w-full md:w-64" data-id="element-2490">
              <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" data-id="element-2491" />
              <Input placeholder="Cari daerah atau provinsi..." className="pl-9" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-2492" />
            </div>
            <div className="w-full md:w-48" data-id="element-2493">
              <Select data-id="element-2494">
                <option data-id="element-2495">Semua Provinsi</option>
                <option data-id="element-2496">Jawa Barat</option>
                <option data-id="element-2497">Jawa Timur</option>
                <option data-id="element-2498">DKI Jakarta</option>
              </Select>
            </div>
            <div className="w-full md:w-48" data-id="element-2499">
              <Select data-id="element-2500">
                <option data-id="element-2501">Semua Status</option>
                <option data-id="element-2502">Hijau (Baik)</option>
                <option data-id="element-2503">Kuning (Perlu Perhatian)</option>
                <option data-id="element-2504">Merah (Bermasalah)</option>
              </Select>
            </div>
          </div>

          <div className="flex gap-2" data-id="element-2505">
            <Button variant="outline" className="flex items-center gap-2" data-id="element-2506">
              <Filter className="h-4 w-4" data-id="element-2507" /> Filter
            </Button>
            <Button variant="outline" className="flex items-center gap-2 bg-white hover:bg-gray-50" onClick={handleExport} disabled={isExporting} data-id="element-2508">
              <Download className={`h-4 w-4 ${isExporting ? 'animate-bounce' : ''}`} data-id="element-2509" />
              {isExporting ? 'Exporting...' : 'Export CSV'}
            </Button>
          </div>
        </div>
      </div>

      <DataTable data={filteredData} columns={columns} keyExtractor={item => item.id} onRowClick={item => setSelectedRegion(item)} data-id="element-2510" />

      {/* Region Detail Modal */}
      <Modal isOpen={!!selectedRegion} onClose={() => setSelectedRegion(null)} title={selectedRegion ? `Detail Kinerja: ${selectedRegion.name}` : 'Detail Daerah'} description={selectedRegion?.province} size="2xl" footer={<div className="flex justify-between w-full" data-id="element-2512">
            <Button variant="outline" onClick={() => console.log('Compare')} data-id="element-2513">
              Bandingkan Daerah
            </Button>
            <Button onClick={() => setSelectedRegion(null)} data-id="element-2514">Tutup</Button>
          </div>} data-id="element-2511">
        {selectedRegion && <div className="space-y-6" data-id="element-2515">
            {/* Top Stats */}
            <div className="grid grid-cols-3 gap-4" data-id="element-2516">
              <div className="p-4 bg-gray-50 rounded-lg border text-center" data-id="element-2517">
                <p className="text-sm text-gray-500" data-id="element-2518">Skor Total</p>
                <p className="text-3xl font-bold text-primary-600" data-id="element-2519">
                  {selectedRegion.score}
                </p>
                <StatusBadge status={selectedRegion.status} className="mt-2" data-id="element-2520">
                  {selectedRegion.status === 'hijau' ? 'Sangat Baik' : 'Perlu Perhatian'}
                </StatusBadge>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg border text-center" data-id="element-2521">
                <p className="text-sm text-gray-500" data-id="element-2522">Ranking Nasional</p>
                <p className="text-3xl font-bold text-gray-900" data-id="element-2523">#12</p>
                <p className="text-xs text-green-600 mt-1" data-id="element-2524">Naik 3 posisi</p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg border text-center" data-id="element-2525">
                <p className="text-sm text-gray-500" data-id="element-2526">SLA Respon</p>
                <p className="text-3xl font-bold text-gray-900" data-id="element-2527">
                  {selectedRegion.sla}
                </p>
                <p className="text-xs text-gray-500 mt-1" data-id="element-2528">
                  Target: &lt; 2 hari
                </p>
              </div>
            </div>

            {/* Charts Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2529">
              <div className="border rounded-lg p-4" data-id="element-2530">
                <h4 className="font-medium text-gray-900 mb-4" data-id="element-2531">
                  Tren Skor (6 Bulan)
                </h4>
                <div className="h-64" data-id="element-2532">
                  <ResponsiveContainer width="100%" height="100%" data-id="element-2533">
                    <LineChart data={trendData} data-id="element-2534">
                      <CartesianGrid strokeDasharray="3 3" vertical={false} data-id="element-2535" />
                      <XAxis dataKey="month" axisLine={false} tickLine={false} data-id="element-2536" />
                      <YAxis domain={[0, 100]} axisLine={false} tickLine={false} data-id="element-2537" />
                      <Tooltip data-id="element-2538" />
                      <Line type="monotone" dataKey="score" stroke="#0284c7" strokeWidth={2} dot={{
                    r: 4
                  }} data-id="element-2539" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>

              <div className="border rounded-lg p-4" data-id="element-2540">
                <h4 className="font-medium text-gray-900 mb-4" data-id="element-2541">
                  Breakdown Penilaian
                </h4>
                <div className="space-y-4" data-id="element-2542">
                  {categoryScoreData.map((cat, idx) => <div key={idx} data-id="element-2543">
                      <div className="flex justify-between text-sm mb-1" data-id="element-2544">
                        <span className="text-gray-700" data-id="element-2545">
                          {cat.category}{' '}
                          <span className="text-xs text-gray-400" data-id="element-2546">
                            ({cat.weight})
                          </span>
                        </span>
                        <span className="font-medium" data-id="element-2547">{cat.score}/100</span>
                      </div>
                      <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-2548">
                        <div className={`h-2 rounded-full ${cat.score >= 90 ? 'bg-green-500' : cat.score >= 70 ? 'bg-yellow-500' : 'bg-red-500'}`} style={{
                    width: `${cat.score}%`
                  }} data-id="element-2549"></div>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>

            {/* Catatan Pembinaan */}
            <div className="border rounded-lg p-4 bg-yellow-50 border-yellow-100" data-id="element-2550">
              <h4 className="font-medium text-yellow-800 mb-2 flex items-center gap-2" data-id="element-2551">
                <FileText className="h-4 w-4" data-id="element-2552" /> Catatan Pembinaan
              </h4>
              <Textarea placeholder="Tulis catatan pembinaan untuk daerah ini..." className="bg-white min-h-[100px]" value={adminNote} onChange={e => setAdminNote(e.target.value)} data-id="element-2553" />
              <div className="flex justify-end mt-2" data-id="element-2554">
                <Button size="sm" className="bg-yellow-600 hover:bg-yellow-700 text-white" data-id="element-2555">
                  Simpan Catatan
                </Button>
              </div>
            </div>

            {/* Recent Activity List */}
            <div data-id="element-2556">
              <h4 className="font-medium text-gray-900 mb-3" data-id="element-2557">
                Laporan Terakhir
              </h4>
              <div className="border rounded-lg overflow-hidden" data-id="element-2558">
                <table className="w-full text-sm" data-id="element-2559">
                  <thead className="bg-gray-50" data-id="element-2560">
                    <tr data-id="element-2561">
                      <th className="px-4 py-2 text-left" data-id="element-2562">ID</th>
                      <th className="px-4 py-2 text-left" data-id="element-2563">Aktivitas</th>
                      <th className="px-4 py-2 text-left" data-id="element-2564">Tanggal</th>
                      <th className="px-4 py-2 text-left" data-id="element-2565">Status</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y" data-id="element-2566">
                    <tr data-id="element-2567">
                      <td className="px-4 py-2 font-mono text-xs" data-id="element-2568">RPT-001</td>
                      <td className="px-4 py-2" data-id="element-2569">Laporan Harian TPA</td>
                      <td className="px-4 py-2 text-gray-500" data-id="element-2570">
                        Hari ini, 09:00
                      </td>
                      <td className="px-4 py-2" data-id="element-2571">
                        <StatusBadge status="hijau" data-id="element-2572">Valid</StatusBadge>
                      </td>
                    </tr>
                    <tr data-id="element-2573">
                      <td className="px-4 py-2 font-mono text-xs" data-id="element-2574">RPT-002</td>
                      <td className="px-4 py-2" data-id="element-2575">Sosialisasi RW 05</td>
                      <td className="px-4 py-2 text-gray-500" data-id="element-2576">
                        Kemarin, 14:30
                      </td>
                      <td className="px-4 py-2" data-id="element-2577">
                        <StatusBadge status="hijau" data-id="element-2578">Valid</StatusBadge>
                      </td>
                    </tr>
                    <tr data-id="element-2579">
                      <td className="px-4 py-2 font-mono text-xs" data-id="element-2580">ISU-882</td>
                      <td className="px-4 py-2" data-id="element-2581">Tumpukan Sampah Liar</td>
                      <td className="px-4 py-2 text-gray-500" data-id="element-2582">2 Feb 2024</td>
                      <td className="px-4 py-2" data-id="element-2583">
                        <StatusBadge status="kuning" data-id="element-2584">Proses</StatusBadge>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>}
      </Modal>
    </CommandCenterLayout>;
}